import { STORE_USER_WALLET } from '../../constants/actionTypes'

const initialState = {}

const userWallet = (state = initialState, action) => {
  switch (action.type) {
    case STORE_USER_WALLET:
      return { ...state, ...action.content }
    default:
      return state
  }
}

export default userWallet
